import { RequestFieldsEnum } from '@/enums/RequestFieldsEnum'
import { useBaseRequest } from '@/hooks/useBaseRequest'
import { useOrgScopedQueryCacheKey } from '@/hooks/useOrgScopedQueryCacheKey'
import { cartsClient } from '@/lib/clients/cartsClient'

export const useCartRequest = () => {
  const { cartBaseRequest } = useBaseRequest()
  const cartReq = { ...cartBaseRequest, fields: RequestFieldsEnum.Full }
  const cartCacheKey = useOrgScopedQueryCacheKey(cartsClient.getCart.name, cartReq)

  return { cartReq, cartCacheKey }
}
